import { Box, Button, Text } from "grommet";
import Link from "next/link";
import { useMemo } from "react";
import { useIsLarge } from "@cybertools/grommet/useIsLarge";
import Layout from "@components/layout";
import Breadcrumb from "@components/breadcrumb";
import transformResponse from "@organisms/coin/transformResponse";
import UserReminder from "@organisms/airdrop/userReminder";
import Tabs from "./tabs";
import Heading from "./heading";

const Container = ({ subtitle, bySlug, breadcrumb, children, ...rest }) => {
  bySlug = useMemo(
    () =>
      Object.keys(bySlug).reduce((acc, slug) => {
        acc[slug] = transformResponse(bySlug[slug]);
        return acc;
      }, {}),
    [bySlug]
  );

  const large = useIsLarge();

  return (
    <Layout coins={bySlug} {...rest}>
      <Breadcrumb links={breadcrumb} />

      <UserReminder margin={{ bottom: "medium" }} />

      <Heading>{subtitle}</Heading>

      <Box
        direction="row"
        justify="between"
        margin={{ top: "large", bottom: "small" }}
        overflow={{ horizontal: "auto" }}
      >
        <Tabs />
        {large && (
          <Link href="/requestairdrop" passHref legacyBehavior>
            <Button
              primary
              size="medium"
              label="Create an Airdrop"
              fill={large ? false : "horizontal"}
              data-ga={`airdrop::click::create`}
            />
          </Link>
        )}
      </Box>

      {children}

      <Box
        margin={{ top: "xlarge" }}
        direction={large ? "row" : "column"}
        justify="center"
        align="center"
        gap="medium"
        alignSelf="center"
        wrap
      >
        <Text size="large">Ready to stand out?</Text>
        <Link href="/requestairdrop" passHref legacyBehavior>
          <Button
            primary
            size="large"
            label="Create an Airdrop"
            fill={large ? false : "horizontal"}
            data-ga={`airdrop::click::create`}
          />
        </Link>
      </Box>
    </Layout>
  );
};

export default Container;
